import Notifier from 'common/helpers/Notifier';
import { coreApi } from 'src/api/config';
import { get } from 'lodash';

export default function createDocumentConsent({
  contactId, hasPlatformConsent, documentsFileList, consentMethod, createCustomConsents,
}) {
  return async () => {
    try {
      let response = {
        status: 201,
      };

      if (!hasPlatformConsent) {
        response = await coreApi.createRecord('consent', {
          state: 'accepted',
          consent_method: consentMethod,
          submission_method: 'file_upload',
          person: contactId,
        });
        const id = get(response, 'data.data.id');
        await coreApi.uploadFile('consent', id, documentsFileList[0]);
      }

      if (typeof createCustomConsents === 'function') {
        await createCustomConsents();
      }

      Notifier.dispatch(response.status, 'Your consent has been recorded.');
      return response;
    } catch (error) {
      Notifier.handleErrors(error);
      return error;
    }
  };
}
